// Parses a value (number, numeric string, null, undefined, "", NaN, etc.)
// into a finite number, or null when it does not represent a usable bound.
export const toFiniteNumber = value => {
  if (value === null || value === undefined || value === "") return null;

  const num = typeof value === "number" ? value : Number(value);

  return Number.isFinite(num) ? num : null;
};
